

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';



export interface  InventoryPurchaseReturnDetailsParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;

}

export interface  InventoryPurchaseReturnDetails {
  [medicine: string]: any;
  id: any;


  returnId: string;

  productId: string;

  qty: Number;

  batchNum: string;

  expiryDate: string;

  costPrice: Number;

  unitsStrip: Number;

  mrpPerStrip: Number;

  freeStrips: Number;

  discountPer: Number;

  discountValue: Number;

  amount: Number;

  gstTotalPer: string;

  igstPer: Number;

  sgstPer: Number;

  cgstPer: Number;

  gstTotalValue: Number;

  igstValue: Number;

  cgstValue: Number;

  sgstValue: Number;

  gstPer: Number;

  taxableAmount: Number;

  payableAmount: Number;

  tenantId: string;

  branchId: string;

  sellPriceStrip: Number; 
  unitSellPrice: Number;
  
  parameters?:  InventoryPurchaseReturnDetailsParameter[];
  links?: any;
}

export abstract class  InventoryPurchaseReturnDetailsData {

  abstract list(url: string): Observable<InventoryPurchaseReturnDetails[]>;
  abstract create(url: string, data:  InventoryPurchaseReturnDetails): Observable<any>;
  abstract update(url: string, data:  InventoryPurchaseReturnDetails): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
